import { render, staticRenderFns } from "./Asignacion_sede_v4.vue?vue&type=template&id=fa83087c&scoped=true"
import script from "./Asignacion_sede_v4.vue?vue&type=script&lang=js"
export * from "./Asignacion_sede_v4.vue?vue&type=script&lang=js"
import style0 from "./Asignacion_sede_v4.vue?vue&type=style&index=0&id=fa83087c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa83087c",
  null
  
)

export default component.exports